/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A color
 * @export
 */
export const Color = {
    Blue: 'BLUE',
    Green: 'GREEN',
    Red: 'RED',
    Yellow: 'YELLOW'
} as const;
export type Color = typeof Color[keyof typeof Color];


export function instanceOfColor(value: any): boolean {
    for (const key in Color) {
        if (Object.prototype.hasOwnProperty.call(Color, key)) {
            // @ts-ignore
            if (Color[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ColorFromJSON(json: any): Color {
    return ColorFromJSONTyped(json, false);
}

export function ColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): Color {
    return json as Color;
}

export function ColorToJSON(value?: Color | null): any {
    return value as any;
}

